import type {
  AllStoresSortableColumn,
  ParamsGetMerchflows_merchflowId_StoresAll,
} from "@CommonApi/merchflows/_merchflowId_/stores/all";

type StoresAllSort = Pick<ParamsGetMerchflows_merchflowId_StoresAll, "sortBy" | "sortDirection">;

export const getNextStoresAllSort = (
  currentSort: StoresAllSort,
  sortBy: AllStoresSortableColumn,
): StoresAllSort => {
  if (currentSort.sortBy !== sortBy || !currentSort.sortDirection) {
    return {
      sortBy,
      sortDirection: "asc",
    };
  }

  if (currentSort.sortDirection === "asc") {
    return {
      sortBy,
      sortDirection: "desc",
    };
  }

  return {
    sortBy: undefined,
    sortDirection: undefined,
  };
};
